import { useRef } from "react"

/**
 * A custom hook that stores and returns the previous value of a variable.
 * Useful for comparing previous and current state/props in `useEffect` or other logic.
 * 
 * @param {*} value - The current value to track.
 * @returns {*} The previous value from the last render cycle.
 */
export default function usePrevious(value) {
    const currentRef = useRef(value)
    const previousRef = useRef()
    if (currentRef.current !== value) {
        previousRef.current = currentRef.current
        currentRef.current = value
    }
    return previousRef.current
}